import React, { Component } from 'react';
import Heading from '../../common/Heading';
import RoundIcon from './RoundIcon';
import IntlMessages from '../../../util/IntlMessages';
import { Share } from '../../../util/Share';

class KAMDetail extends Component {
  state = {
    sellerData: undefined,
  };
  componentDidUpdate(prevProps) {
    if (prevProps.seller !== this.props.seller) {
      this.setState({ sellerData: this.props.seller });
    }
  }
  render() {
    let { sellerData } = this.state;
    return (
      <div>
        <Heading title={<IntlMessages id="app.SalesPersonDetails" />} className="p-0" />
        {sellerData && Object.keys(sellerData).length !== 0 ? (
          <>
            <div className="kamDetailBlock">
              <div className="KamDetailItem">
                <span>
                  <img src={require('../../../assets/svg/Dashboard/user.svg')} alt="" />
                </span>
                <span>
                  {sellerData.firstName ? sellerData.firstName : '--'}
                  {sellerData.lastName ? sellerData.lastName : '--'}
                </span>
              </div>
              <div className="KamDetailItem">
                <span>
                  <img src={require('../../../assets/svg/Dashboard/email.svg')} alt="" />
                </span>
                <span>{sellerData.email ? sellerData.email : '--'}</span>
              </div>
              <div className="KamDetailItem">
                <span>
                  <img src={require('../../../assets/svg/phonecall.svg')} alt="" />
                </span>
                <span>{sellerData.mobile ? sellerData.mobile : '--'}</span>
              </div>
              <div className="KamDetailItem">
                <RoundIcon onClick={Share.whatsApp} image={require('../../../assets/svg/Dashboard/whatsapp.svg')} />
                <RoundIcon
                  onClick={() => {
                    window.open('https://web.skype.com/', '_blank');
                  }}
                  image={require('../../../assets/svg/Dashboard/skype.svg')}
                />
              </div>
            </div>
          </>
        ) : (
          'No Seller Data'
        )}
      </div>
    );
  }
}
export default KAMDetail;
